import { API_URL } from 'constants';

export const DEFAULT_EMPLOYEE_URL = `${API_URL}/api/v1/employee`;
